/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
const RECORD_PAYMENT_METHOD_TYPE = 'MFE/CHECKOUT/RECORD_PAYMENT_METHOD_TYPE';
const RECORD_PAYMENT_METHOD_TYPE_COMPLETED = 'MFE/CHECKOUT/RECORD_PAYMENT_METHOD_TYPE_COMPLETED';

export default {
    RECORD_PAYMENT_METHOD_TYPE,
    RECORD_PAYMENT_METHOD_TYPE_COMPLETED,
};
